import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js';

// Connects to data-controller="search-pacientes-guardia"
export default class extends Controller {
  static targets = ['searchInput', 'obraSocial', 'desde', 'hasta', 'allGuardiaCheckbox'];
  static values = {
    url: String
  }

  onClickPerformSearch(event) {
    event.preventDefault();
    let obraSocialValue = null;

    if (this.obraSocialTarget.value && this.obraSocialTarget.value !== 'Obra social') {
      obraSocialValue = this.obraSocialTarget.value;
    }

    get(this.urlValue, {
      responseKind: 'turbo-stream',
      query: {
        q_guardia: this.searchInputTarget.value || null,
        obra_social_guardia: obraSocialValue,
        desde_guardia: this.desdeTarget.value || null,
        hasta_guardia: this.hastaTarget.value || null,
        all_guardia: this.allGuardiaCheckboxTarget.checked,
      }
    })
  }
}
